import React from 'react';
import BottomNav from '../components/BottomNav';

const PrimeRealEstate = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Prime Real Estate</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Exclusive Property Portfolio</p>
        
        <div className="card">
          <p>
            Access the world's most prestigious properties. From penthouses to private islands, 
            we connect you with extraordinary real estate opportunities.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Global Listings</h3>
              <p>Exclusive properties in prime locations worldwide</p>
            </div>
            <div className="feature-item">
              <h3>Investment Advisory</h3>
              <p>Expert guidance on real estate investments</p>
            </div>
            <div className="feature-item">
              <h3>Private Viewings</h3>
              <p>Discreet property tours and exclusive access</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default PrimeRealEstate;
